import React from 'react';
import {
  Dialog,
  Typography,
  DialogContent,
  Box,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { makeStyles } from 'utils/makeStylesAdapter';
import { HeaderModal, ButtonConsensus } from 'components';
import { useTheme } from '@mui/material/styles';
import { colors } from 'utils/colorsSteps';

const useStyles = makeStyles(theme => ({
  root: {},
  modal: {
    fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
  },
  containerBtn: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: theme.spacing(2, 1, 2, 1),
  },
  btn: {
    marginRight: theme.spacing(2),
  },
  text: {
    padding: theme.spacing(2, 2, 2, 2),
  },
}));

const ModalConfirm = props => {
  const {
    open,
    onClose,
    confirm,
    disabledBtnModalConfirm,
    setDisabledBtnModalConfirm,
    boundInquiryId,
    checkedPoliceInquiryNumberClass,
    manipulateChecks,
    showCopyFilesCheckbox,
    copyFilesFromBoundInquiry,
    setCopyFilesFromBoundInquiry,
  } = props;

  const classes = useStyles();

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleConfirmRequest = () => {
    setDisabledBtnModalConfirm(true);
    confirm();
  };

  return (
    <>
      <Dialog
        fullScreen={fullScreen}
        onClose={onClose}
        open={open}
        aria-labelledby="responsive-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <HeaderModal onClose={onClose}>Alerta</HeaderModal>
        <DialogContent>
          <Box className={classes.text}>
            {checkedPoliceInquiryNumberClass.length > 0 && (
              <Typography variant="h5">
                Existe um inquérito com o mesmo número IP e com a mesma classe.
                <br />
                Ao confirmar, os arquivos deste inquérito pendente serão anexados ao inquérito já
                existente.
              </Typography>
            )}
            {manipulateChecks.length > 2 && (
              <Typography variant="h5">Três ou mais arquivos serão importados.</Typography>
            )}
            {!boundInquiryId && (
              <Typography variant="h5">Você não vinculou este inquérito a nenhum outro.</Typography>
            )}
            {showCopyFilesCheckbox ? (
              <Typography variant="h5">Confirma o salvamento do inquérito?</Typography>
            ) : (
              <Typography variant="h5">Deseja continuar?</Typography>
            )}
          </Box>
          {showCopyFilesCheckbox && (
            <Box px={2} pb={1}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!copyFilesFromBoundInquiry}
                    onChange={e => setCopyFilesFromBoundInquiry(e.target.checked)}
                    name="copyFilesFromBoundInquiry"
                    color="primary"
                  />
                }
                label="Copiar os arquivos do APFD vinculado"
              />
            </Box>
          )}
          <Box className={classes.containerBtn}>
            <ButtonConsensus
              title="Cancelar"
              backgroundColor="#fff"
              hovercolor={colors.greySecundary}
              color={colors.greyShadow}
              onClick={onClose}
            />
            <ButtonConsensus
              title="Confirmar"
              backgroundColor={colors.primary}
              hovercolor={colors.primary}
              disabled={disabledBtnModalConfirm}
              onClick={handleConfirmRequest}
            />
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ModalConfirm;
